module.exports = __webpack_public_path__ + "static/img/catridge.ca7c344f.png";